module.exports = __webpack_public_path__ + "static/media/explore-more-icon-1.d76d4870.svg";